module.exports = __webpack_public_path__ + "why16.webp?0bb4a208fc1ab82382f794cdadb57c52";